import React from "react";
import T from "prop-types";

export function FixniPozadavkyBoxObdobiItem({ label, obdobi }) {
  return !obdobi ? undefined : (
    <div className="b2b-FixniPozadavkyBoxObdobiItem">
      <div className="b2b-FixniPozadavkyBoxObdobiItem-label">{label}</div>
      <div className="b2b-FixniPozadavkyBoxObdobiItem-day">
        {obdobi.openDay}
      </div>
      <div className="b2b-FixniPozadavkyBoxObdobiItem-hours">
        {obdobi.openHours}
      </div>
      <div className="b2b-FixniPozadavkyBoxObdobiItem-day">
        {obdobi.closeDay}
      </div>
      <div className="b2b-FixniPozadavkyBoxObdobiItem-hours">
        {obdobi.closeHours}
      </div>
    </div>
  );
}

FixniPozadavkyBoxObdobiItem.propTypes = {
  label: T.string,
  obdobi: T.object
};

export default React.memo(FixniPozadavkyBoxObdobiItem);
